import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import { Modal } from 'react-bootstrap';
import ErrorAlert from 'components/ui/ErrorAlert';
import { intentMap } from 'utils/formatters/stops';
import LocationDetails from './details/LocationDetails';
import { withTranslation } from 'react-i18next';

class EditStopLocationModal extends Component {
  static propTypes = {
    stop: PropTypes.object,
  }

  constructor(props) {
    super(props);
    const stop = props.stop || {};

    const {
      action,
      empty,
    } = stop;
    const prefix = empty ? '_empty' : '';
    const action_type = `${action}${prefix}`;
    this.state = {
      validationErrors: {},
      action_type,
      window_start: stop.window_start,
      window_end: stop.window_end,
      name: stop && stop.location ? stop.location.name : '',
      address: stop && stop.location ? stop.location.address : '',
      contacts: stop.contacts || [],
      stopPending: false,
      equipments: stop.equipments || [],
    };
  }

  handleClose = () => {
    this.props.onClose();
  }

  handleFieldChange = field => e => this.setState({ [field]: e.target.value });
  handleWindowDateChange = field => date => this.setState({ [field]: date });

  handleAddContact = () => {
    const contacts = [
      ...this.state.contacts,
      {
        name: '',
        phone: '',
      },
    ];
    this.setState({ contacts });
  }

  handleLocationDetailsRemoveContact = (index) => {
    const contacts = [
      ...this.state.contacts.slice(0, index),
      ...this.state.contacts.slice(index + 1),
    ];
    this.setState({ contacts });
  }

  handleContactFieldChange = (index, formField, value) => {
    const contact = { ...this.state.contacts[index] };
    contact[formField] = value;
    const contacts = [
      ...this.state.contacts.slice(0, index),
      contact,
      ...this.state.contacts.slice(index + 1),
    ];
    this.setState({ contacts });
  }

  handleLocationDetailsFieldChange = address => this.setState({ address });

  validate(data) {
    const validationErrors = {};
    const { t } = this.props;
    if (!data.address) {
      validationErrors.address = t('SET_AN_ADDRESS');
    }

    if (!data.name) {
      validationErrors.name = t('SET_A_NAME');
    }

    this.setState({
      validationErrors,
    });

    return validationErrors;
  }

  handleSave = () => {
    const intent = intentMap[this.state.action_type.toLowerCase()];
    const { action, empty } = intent;
    const stop = {
      action,
      empty,
      contacts: this.state.contacts,
      window_start: this.state.window_start,
      window_end: this.state.window_end,
      location: {
        name: this.state.name,
        address: this.state.address,
      },
      equipments: this.state.equipments,
    };

    const validationErrors = this.validate(stop.location);

    if (Object.keys(validationErrors).length === 0) {
      this.setState({
        stopPending: true,
      }, () => this.props.onSave(stop));
    }
  }

  renderLocationDetails() {
    let errors = {};
    const { validationErrors } = this.state;

    if (validationErrors.address) {
      errors = { address: validationErrors.address };
    }

    if (validationErrors.name) {
      errors = { name: validationErrors.name };
    }

    return (
      <LocationDetails
        locationAddressId="edit-stop-location-address"
        locationNameId="edit-stop-location-name"
        action_type={this.state.action_type}
        name={this.state.name}
        address={this.state.address}
        window_start={this.state.window_start}
        window_end={this.state.window_end}
        contacts={this.state.contacts}
        sectionTitle=""
        errors={errors}
        onAddContact={this.handleAddContact}
        onRemoveContact={this.handleLocationDetailsRemoveContact}
        onChange={this.handleFieldChange}
        onWindowDateChange={this.handleWindowDateChange}
        onAddressChange={this.handleLocationDetailsFieldChange}
        onContactFieldChange={this.handleContactFieldChange}
      />
    );
  }

  renderValidationErrors() {
    const validationErrorKeys = Object.keys(this.state.validationErrors);
    if (validationErrorKeys.length === 0) {
      return null;
    }
    const { t } = this.props;
    return (
      <div className="w-full">
        <ErrorAlert
          title={t('MISSING_FIELDS')}
        >
          <ul>
            {validationErrorKeys.map(key => (
              <li>{this.state.validationErrors[key]}</li>
            ))}
          </ul>
        </ErrorAlert>
      </div>
    );
  }

  renderActions() {
    const { t } = this.props;
    return (
      <div className="actions-wrapper">
        <div className="flex">
          {this.renderValidationErrors()}
        </div>
        <div className="flex justify-end">
          <div className="button-group flex">
            <button
              className="block mr-2 button button-green"
              disabled={this.state.stopPending}
              onClick={this.handleSave}
            >
              {this.state.stopPending && (
                <i className="fa fa-circle-o-notch fa-spin mr-2" />
              )}
              {t('SAVE_STOP')}
            </button>
            <button
              className="block button secondary-action"
              onClick={this.handleClose}
            >
              {t('CANCEL')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Modal
        show
        onHide={this.handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <div className="flex justify-between content-center">
            <h3 className="m-0">{t('LOCATION_DETAILS')}</h3>
            <div className="flex justify-end">
              <a
                className="secondary-action hover:no-underline text-lg font-bold"
                onClick={this.handleClose}
              >
                &times;
              </a>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {this.renderLocationDetails()}
          {this.renderActions()}
        </Modal.Body>
      </Modal>
    );
  }
}

EditStopLocationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default  withTranslation()(EditStopLocationModal);